export const theme = {
  padding: '20px',
  primaryText: '#ffffff',
  white: '#ffffff',
  button: '#226fbe',
  buttonHover: '#5f9efe',
  buttonOff: '#eeeeee',
  emperor: '#535353',
  mineShaft: '#333333',
  white90: 'rgba(255, 255, 255, 0.9)',
  white20: 'rgba(255, 255, 255, 0.2)',
  malibu: '#5f9efe',
  veniceBlue: '#0b639a',
  black10: 'rgba(0, 0, 0, 0.1)',
  black5: 'rgba(0, 0, 0, 0.05)',
  gray: '#888888'
};
